import videos from "./dataset/videos.json";

export default videos;